export const switchTab = (trigger) => {
    const container = trigger.closest('[data-tabs]');

    if (!container) {
        return;
    }

    const targetPanel = trigger.dataset.tabTrigger;

    container.querySelectorAll('[data-tab-trigger]').forEach(tab => {
        tab.classList.toggle('active', tab.dataset.tabTrigger === targetPanel);
    });

    container.querySelectorAll('[data-tab-panel]').forEach(panel => {
        panel.classList.toggle('active', panel.dataset.tabPanel === targetPanel);
    });
};
